import { Status, States } from '@sift/resift/models/Status';
import { setStatus } from 'store/themes/actions/setStatus';
import createTheme from 'store/themes/actions/_helpers/createTheme';
import { fetchThemes } from 'store/themes/actions/getThemes';
import { setPreviewThemeId } from 'store/themes/actions/setPreviewThemeId';

export function createPreviewTheme({ settings, logoUrl, backgroundUrl, pictureUrl }) {
  return async dispatch => {
    try {
      dispatch(setStatus(new Status(States.LOADING)));

      // create the preview theme
      const previewTheme = await createTheme({ settings, logoUrl, backgroundUrl, pictureUrl });
      dispatch(setPreviewThemeId(previewTheme.id));
      // then refetch the themes to include the new preview theme
      await dispatch(fetchThemes());

      await dispatch(setStatus(new Status(States.NORMAL)));
    } catch (e) {
      dispatch(setStatus(new Status(States.ERROR)));
    }
  };
}
